import React, { useState } from "react";
import Modal from 'react-bootstrap/Modal';
import { Button } from 'react-bootstrap';


export interface InformationModalProps {
    modalState: InformationModalState;
}

const InformationModal: React.FC<InformationModalProps> = (props: InformationModalProps) => {

    return <Modal show={props.modalState.isShowing} backdrop="static">
        <Modal.Header>
            <Modal.Title>
                {props.modalState.title}
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            {props.modalState.text}
        </Modal.Body>
        <Modal.Footer>
            <div className="pull-right mt-3">
                <Button variant="primary" onClick={props.modalState.onClose}>
                    Close
                </Button>
            </div>
        </Modal.Footer>
    </Modal>
}

export default InformationModal;

export interface InformationModalState {
    isShowing: boolean;
    title?: React.ReactNode;
    text?: React.ReactNode;
    onClose?: (() => void);
}

export interface InformationModalController {
    show(title: React.ReactNode, text: React.ReactNode, closeHandler?: (() => void)): void;
    state: InformationModalState;
}

export function useInformationModal(): InformationModalController {
    const [state, setState] = useState<InformationModalState>({isShowing: false, title: "", text: "", onClose: null});

    function onClose() {
        setState({ ...state, isShowing: false});
        if (state.onClose) state.onClose();
    }

    function show(title: React.ReactNode, text: React.ReactNode, closeHandler: (() => void)) {
        setState({...state, isShowing: true, title, text, onClose})
    }

    return {
        state: {
            isShowing: state.isShowing,
            title: state.title,
            text: state.text,
            onClose
        },
        show
    }

}